export default __webpack_public_path__ + "static/media/Sticker.d44be345.svg";